/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import axios from 'axios/dist/axios.min.js'

class PipelineCashBack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      getCouponsSuccess: {},
      couponRepeatGet: {},
      getCouponsResult: null,
      show_toast: false,
      toast_text: '',
    };
    this.interval = null;
  }

  componentDidMount() {
    const { imgsList } = this.props.config;
    imgsList[0] && this.setState({
      getCouponsSuccess: imgsList[0].cashBackConfig.getCouponsSuccess,
      couponRepeatGet: imgsList[0].cashBackConfig.couponRepeatGet,
    });
  }

  handleItemClick = () => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        props: this.props,
      })
      return
    }

    utils.uploadTrack(this.props);

    const u = utils.getCookie("u");
    const ua = utils.getCookie("ua");
    Promise.all([u, ua]).then(values => {
      if (values[0] && values[1]) {
        this.cashBackSend();
      } else {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login",
        });
      }
    });
  }

  // 通用返现券-领取
  cashBackSend = () => {
    const { imgsList } = this.props.config;
    let activity_code;
    for (const item of imgsList) {
      const code = item.cashBackConfig.activity_code;
      if (code) {
        activity_code = code;
        break;
      }
    }
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-laxincommonapi/cash_back/send?access_token=2322TizdV3pjw8CBsy',
      method: 'post',
      withCredentials: true,
      data: {
        activity_code,
      },
    }).then(res => {
      const { status, msg } = res.data;
      if (status === 0 || status == 200) {
        this.setState({
          getCouponsResult: status
        }); 
      } else {
        this.setState({
          show_toast: true,
          toast_text: msg
        })
      }
    })
  }

  renderCashBackPopup = () => {
    const { getCouponsResult, getCouponsSuccess, couponRepeatGet } = this.state;
    if (!getCouponsResult && getCouponsResult !== 0) {
      return null;
    } else if (getCouponsResult === 0) {
      return (
        <div className="popup">
          <div className="mask" onClick={this.resultImageClick.bind(this, false)}></div>
          <img
            className="result-image"
            src={utils.formatImgUrl(getCouponsSuccess.src, this.props.webpSupport)}
            style={{width: getCouponsSuccess.imageWidth}}
            onClick={this.resultImageClick.bind(this, true)}
          />
        </div>
      )
    } else {
      return (
        <div className="popup">
          <div className="mask" onClick={this.resultImageClick.bind(this, false)}></div>
          <img
            className="result-image"
            src={utils.formatImgUrl(couponRepeatGet.src, this.props.webpSupport)}
            style={{width: couponRepeatGet.imageWidth}}
            onClick={this.resultImageClick.bind(this, true)}
          />
        </div>
      )
    }
  }

  resultImageClick = (isAnchor) => {
    this.setState({
      getCouponsResult: null
    }, () => {
      isAnchor && setTimeout(() => {
        const navOffsetTop = window.document.querySelector('.navigation-container-static').offsetTop - this.props.navigationBarHeight;
        window.scrollTo(0, navOffsetTop);
      }, 300) 
    });
  }

  renderToast = () => {
    const { show_toast, toast_text } = this.state;
    if (show_toast) {
      this.interval && clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.setState({
          show_toast: false,
          toast_text: ''
        });
      }, 3000);
      return <p className="toast">{toast_text}</p>;
    } else {
      return null;
    }
  }

  render() {
    const { baseConfig, imgsList } = this.props.config;

    // 判断不同布局方式下的间距取值
    if (baseConfig.sortType === "一行一图") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.sortType === "一行二图") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.sortType === "一行三图") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.sortType === "banner") {
      Object.assign(baseConfig, baseConfig.layout_banner);
    }

    // 转为数字处理，后续参与计算
    baseConfig.imgMarginHorizon = isNaN(Number(baseConfig.imgMarginHorizon))
      ? 0
      : Number(baseConfig.imgMarginHorizon);
    baseConfig.imgMarginVertical = isNaN(Number(baseConfig.imgMarginVertical))
      ? 0
      : Number(baseConfig.imgMarginVertical);
    return (
      <div
        className="pipeline-cashBack"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="img-list">
          {imgsList.map((item, index) => {
            let rowItemNumber = 3; // 每行排列数量
            if (
              baseConfig.sortType === "一行一图" ||
              baseConfig.sortType === "banner"
            ) {
              rowItemNumber = 1;
            } else if (baseConfig.sortType === "一行二图") {
              rowItemNumber = 2;
            } else if (baseConfig.sortType === "一行三图") {
              rowItemNumber = 3;
            }

            const isFirstRow = Boolean(index < rowItemNumber); // 该项是否在首行
            const isLasthRow = Boolean(imgsList.length - index < rowItemNumber); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 计算每个项的宽度
            const totalMargin =
              (rowItemNumber - 1) * baseConfig.imgMarginHorizon;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
              minHeight: 10,
              marginTop: isFirstRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginLeft: isFirstColumn
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
              marginRight: isLastColumn
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
            };

            // 判断图片圆角值
            let imgBorderRadius = "6px";
            if (baseConfig.sortType === "banner" || baseConfig.noImgRadius) {
              // banner图片或者选择不添加圆角情况，值为0
              imgBorderRadius = "0";
            }
            return (
              <Fragment key={index}>
                <div
                  className="img-item"
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemClick.bind(this, item, index)}
                >
                  <img
                    className="img"
                    style={{ borderRadius: imgBorderRadius }}
                    src={utils.formatImgUrl(item.src, this.props.webpSupport)}
                  />
                </div>
                { this.renderCashBackPopup() }
              </Fragment>
            );
          })}
        </div>
        { this.renderToast() }
      </div>
    );
  }
}

PipelineCashBack.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCashBack };
export default PipelineCashBack;



// WEBPACK FOOTER //
// ./components/pipeline-cashBack/index.js